import { Stack } from "@mui/material";
import React from "react";

const SideBarMenuSectionWrapper = ({ children }) => {
  return (
    <Stack
      spacing={2}
      width="100%"
      // height="100%"
      justifyContent="flex-start"
      alignItems="center"
      bgcolor="grey.g6"
      sx={{ overflowY: "auto", height: "590px", borderRadius: 2 }}
    >
      {children}
    </Stack>
  );
};

export default SideBarMenuSectionWrapper;
